module.exports = __webpack_public_path__ + "media/images/athletes/1796-bc0ea07679516cddc9e20f5a903e53c6.png";